if (!customElements.get('delyme-navigation')) {
  customElements.define('delyme-navigation', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.dialog = this.querySelector('dialog');
      this.openers = [...this.querySelectorAll('[data-menu-open]')];
      this.panels = [...this.querySelectorAll('[data-menu-panel]')];
      this.stack = [];
      this.currentPanel = 'root';
      if (typeof this.dialog?.showModal === 'function') {
        this.openers.forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => this.openMenu(button), options);
        });
        this.querySelector('[data-menu-fallback]').hidden = true;
      }
      this.querySelector('[data-menu-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('cancel', event => {
        if (this.stack.length) {
          event.preventDefault();
          this.goBack();
        }
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.resetMenu(), options);
      this.querySelectorAll('[data-panel-target]').forEach(button => button.addEventListener('click', () => {
        this.stack.push({ panel: this.currentPanel, trigger: button });
        button.setAttribute('aria-expanded', 'true');
        this.showPanel(button.dataset.panelTarget);
        this.panels.find(panel => !panel.hidden)?.querySelector('[data-panel-heading]')?.focus();
      }, options));
      this.querySelectorAll('[data-panel-back]').forEach(button => button.addEventListener('click', () => this.goBack(), options));
      this.popovers = [...this.querySelectorAll('[data-popover]')];
      this.popovers.forEach((popover, index) => {
        const summary = popover.querySelector('summary');
        const panel = popover.querySelector('.delyme-popover__panel');
        panel.id = `${this.dialog.id}-popover-${index}`;
        summary.setAttribute('role', 'button');
        summary.setAttribute('aria-controls', panel.id);
        summary.setAttribute('aria-expanded', String(popover.open));
        popover.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(popover.open));
          if (popover.open) this.popovers.forEach(other => { if (other !== popover) other.open = false; });
        }, options);
        popover.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !popover.open) return;
          event.preventDefault();
          event.stopPropagation();
          popover.open = false;
          popover.querySelector('summary').focus();
        }, options);
        popover.addEventListener('focusout', event => {
          if (event.relatedTarget && !popover.contains(event.relatedTarget)) popover.open = false;
        }, options);
      });
      document.addEventListener('pointerdown', event => {
        this.popovers.forEach(popover => { if (!event.composedPath().includes(popover)) popover.open = false; });
      }, options);
      this.quickLinks = this.querySelector('.delyme-nav__quick');
      this.next = this.querySelector('[data-quick-next]');
      this.next.addEventListener('click', () => {
        this.quickLinks.scrollBy({ left: this.quickLinks.clientWidth * 0.7, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      this.quickLinks.addEventListener('scroll', () => this.updateOverflow(), options);
      this.resizeObserver = new ResizeObserver(() => {
        this.updateOverflow();
        const header = this.closest('.section-header');
        if (header) document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
      });
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.quickLinks);
      this.updateOverflow();
    }

    updateOverflow() {
      this.next.hidden = this.quickLinks.scrollWidth <= this.quickLinks.clientWidth + 2;
      this.next.disabled = this.quickLinks.scrollLeft + this.quickLinks.clientWidth >= this.quickLinks.scrollWidth - 2;
    }

    openMenu(button) {
      this.openedBy = button;
      this.popovers.forEach(popover => { popover.open = false; });
      this.querySelector('predictive-search')?.close?.();
      this.showPanel('root');
      this.stack = [];
      this.dialog.showModal();
      document.body.classList.add('delyme-menu-open');
      this.openers.forEach(opener => opener.setAttribute('aria-expanded', 'true'));
      this.querySelector('[data-menu-close]').focus();
    }

    showPanel(name) {
      this.panels.forEach(panel => { panel.hidden = panel.dataset.menuPanel !== name; });
      this.currentPanel = name;
      this.querySelector('[data-menu-body]').scrollTop = 0;
    }

    goBack() {
      const previous = this.stack.pop();
      if (!previous) return;
      this.showPanel(previous.panel);
      previous.trigger.setAttribute('aria-expanded', 'false');
      previous.trigger.focus();
    }

    resetMenu() {
      document.body.classList.remove('delyme-menu-open');
      this.openers.forEach(opener => opener.setAttribute('aria-expanded', 'false'));
      this.querySelectorAll('[data-panel-target]').forEach(button => button.setAttribute('aria-expanded', 'false'));
      this.stack = [];
      this.showPanel('root');
      const target = this.openedBy?.getClientRects().length ? this.openedBy : this.openers.find(button => button.getClientRects().length);
      target?.focus();
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      document.body.classList.remove('delyme-menu-open');
      this.events?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
